export const emailAnimator="lamalle-animations-senior@outlook.fr"